import { useState, useEffect } from 'react';
import {
    deleteTodo,
    loadTodos,
    postTodo,
    putTodo,
} from '../services/todos';
import { TokenForm } from '../components/TokenForm';
import { TodoForm } from '../components/TodoForm';
import { TodoList } from '../components/TodoList';

export function App() {
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [todos, setTodos] = useState([]);

    const handleDelete = (id) => {
        deleteTodo(token, id).then(() => {
            setTodos(todos.filter((todo) => todo.id !== id));
        });
    };
    const handleComplete = (id) => {
        putTodo(token, id, { completed: true }).then(() => {
            setTodos(todos.map((todo) => {
                if (id !== todo.id) { return todo; }

                todo.completed = true;

                return todo;
            }));
        });
    };
    const handleReopen = (id) => {
        putTodo(token, id, { completed: false }).then(() => {
            setTodos(todos.map((todo) => {
                if (id !== todo.id) { return todo; }

                todo.completed = false;

                return todo;
            }));
        });
    };
    const handleDeleteCompleted = () => {
        setTodos(todos.filter((todo) => {
            if (todo.completed){
                deleteTodo(token, todo.id);

                return false;
            }

            return true;
        }));
    };
    const handleAdd = (title, deadline) => {
        postTodo(token, title, deadline).then((todo) => {
            setTodos([...todos, todo]);
        });
    }

    const handleTokenChange = (token) => {
        localStorage.setItem('token', token);

        setToken(token);
    };

    useEffect(() => {
        if (!token) { return; }

        loadTodos(token)
            .then((todos) => {
                if (!todos) { return; }

                setTodos(todos);
                setLoading(false);
                setError(false);
            })
            .catch(() => {
                setError(true);
                handleTokenChange(null);
            });
    }, [token]);

    return (
        <div className="bg-white min-h-96 overflow-hidden shadow sm:rounded-md">
            {!token && <TokenForm
                onTokenChange={handleTokenChange}
                error={error}
            />}
            {token && !loading && <>
                <TodoForm
                    onAdd={handleAdd}
                />

                <TodoList
                    todos={todos}
                    onDelete={handleDelete}
                    onComplete={handleComplete}
                    onReopen={handleReopen}
                    onDeleteCompleted={handleDeleteCompleted}
                />
            </>}
        </div>
    );
}
